import { render, staticRenderFns } from "./ModalCall.vue?vue&type=template&id=63f7abb1&"
import script from "./ModalCall.vue?vue&type=script&lang=js&"
export * from "./ModalCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports